import React from 'react';
import {msg} from "constants/message";
import {ShowIf, validatable} from 'components/utils';
import {Link} from 'react-router';
import { ThanhTra } from 'api';
import moment from 'moment';

class AutoCompleteKeHoachTT extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.value,
      searching: false,
      openSuggest: false,
      result: [],
      page: {
        totalElements: 0
      },
      isValid: true
    }
  }

  validate() {
    if (!this.state.value.trim()) {
      this.setState({
        isValid: false
      });
      this.textInput.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value != nextProps.value) {
      this.setState({value: nextProps.value});
    }
  }

  handleBlur() {
    setTimeout(() => {
      if (!this.refs.autoCompleteKHTT) {
        return;
      }
      this.setState({
        openSuggest: false
      });
    }, 500);
  }

  handleTyping(e) {
    let value = e.target.value;

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }
    this.setState({
      value
    });
    if (!value) {
      this.state.openSuggest = false;
    } else {
      this.typingTimeout = setTimeout(() => {
        this.setState({searching: true});
        let params = {
          size: 3,
          page: 0,
          soQuyetDinh: value,
          keHoachCurrentId: this.props.keHoachCurrentId
        }
        ThanhTra.actions.getKeHoachThanhTraOld.request('', params).then(res => {
          if (!this.refs.autoCompleteKHTT) {
            return;
          }
          if (res.data && res.data._embedded) {
            this.setState({
              result: res.data._embedded.keHoachThanhTras,
              page: res.data.page,
              openSuggest: true,
              searching: false
            });
          } else {
            this.setState({
              result: [],
              searching: false,
              page: { totalElements: 0 }
            });
          }
        }).catch(err => {
          this.setState({
            result: [],
            searching: false,
            page: { totalElements: 0 }
          });
        });
      }, 1000);
    }
  }

  selectItemAction(item) {
    this.props.onSelect(item);
    this.setState({openSuggest: false});
  }

  viewAllResult(keyword) {
    this.props.onViewAll(keyword);
    this.setState({openSuggest: false});
  }

  render() {
    return (
      <div className="col-input autocomplete-box" ref="autoCompleteKHTT">
        <label className="pt-label wrap-autocomplete">
          <span className="val-title">{this.props.label}
            <ShowIf condition={this.props.isRequired}>
              <span className="text-required pt-text-muted"> *</span>
            </ShowIf>
          </span>

          <input ref={(input) => { this.textInput = input; }}
            className={`pt-input ${this.state.searching ? 'tt-loading' : ''} ${!this.state.isValid && !this.state.value.trim() ? 'pt-intent-danger' : ''}`} maxLength={this.props.maxLength}
            value={this.state.value} onBlur={this.handleBlur.bind(this)}
            onChange={this.handleTyping.bind(this)} type="text" autoComplete = "off"
            name={this.props.name}
          />
          <ShowIf condition={!this.state.searching}>
            <Link onClick={this.viewAllResult.bind(this, this.state.value)} className="search-autocomplete"></Link>
          </ShowIf>
          <ShowIf condition={!this.state.isValid && !this.state.value.trim()}>
            <div className="pt-form-helper-text">{msg.messageDefault}</div>
          </ShowIf>
        </label>
        <div className="autocomplete-container">
          <ShowIf condition={this.state.openSuggest}>
            <ul>
              {
                this.state.result.map((item, i) => {
                  return (
                    <li key={i} className="item-person" onClick={this.selectItemAction.bind(this, item)}>
                      <div className="list-items">
                        <p className="mb10 item-header">{item.quyetDinhPheDuyetKTTT}</p>
                        <p className="mb10 item-content"><span className="title-content">Ngày phê duyệt:&nbsp;</span>{moment(item.ngayRaQuyetDinh).format('DD/MM/YYYY')}</p>
                        <p className="mb10 item-content"><span className="title-content">Năm thanh tra:&nbsp;</span>{item.namThanhTra}</p>
                        <label className="pt-control pt-radio pt5 pt-large checkbox-autocomplete">
                          <input type="radio" name="docs-radio-regular"/>
                          <span className="pt-control-indicator"></span>
                        </label>
                      </div>
                    </li>
                  )
                })
              }
              { this.state.page.totalElements > 3 ? (
                <li>
                  <Link className="btn-view-more" onClick={this.viewAllResult.bind(this, this.state.value)}>
                    Xem thêm {this.state.page.totalElements - 3} kết quả
                  </Link>
                </li>
              ) : null }
            </ul>
          </ShowIf>
        </div>
      </div>
    )
  }
}

AutoCompleteKeHoachTT.defaultProps = {
  isRequired: false,
  name: '',
  label: 'Quyết định phê duyệt KHTT'
}

export default validatable(AutoCompleteKeHoachTT);



// WEBPACK FOOTER //
// ./src/components/modules/auto-complete/AutoCompleteKeHoachTT.jsx